<template>
  <!-- eslint-disable -->
  <div>
    <api-service></api-service>
    <v-dialog class="add-edit-dialog" v-model="addCourier" max-width="800px" :overlay="false" scrollable>
      <v-card tile :class="{'add-edit-open':addCourier}">
        <v-app-bar flat style="background-color: #f5f5f5;">
          <v-btn icon @click.native="close()" class="close-edit-modal">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{courierModel.Name ? courierModel.Name : "New Courier"}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="save-courier-btn" text @click="submit">Save</v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-progress-linear :indeterminate="true" v-show="loading"></v-progress-linear>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container v-if="courierDuplicate" class="duplicate-courier-flag">
              <span style="color:#ff5252">There is Another Courier with the same name and address. Save anyway?</span>
              <v-btn text class="save-duplicate-btn" @click="submit(true)">Yes</v-btn>
              <v-btn text class="close-duplicate-btn" @click.native="close()">No</v-btn>
            </v-container>
            <v-container fluid>
              <h2>Courier Details</h2>
              <v-text-field class="courier-name-field" label="Courier Name" :rules="[rulesRequired]" v-model="courierModel.Name" required></v-text-field>
              <v-text-field class="courier-email-field" label="Dispatch E-mail" v-model="courierModel.Address.Email" :rules="[rulesEmail, rulesRequired]" required></v-text-field>
              <v-text-field class="courier-phone-field" label="Dispatch Phone" v-model="courierModel.Address.Phone" :rules="[rulesPhone, rulesRequired]" required></v-text-field>
              <v-text-field class="courier-address-field" label="Physical Address" :rules="[rulesRequired]" v-model="courierModel.Address.Line1" required></v-text-field>
              <v-layout row wrap>
                <v-text-field class="courier-city-field" label="City" :rules="[rulesRequired]" v-model="courierModel.Address.City" required></v-text-field>
                <v-select class="courier-state-field" :items="states" v-model="courierModel.Address.State" @blur="stateError = null;" label="State" :error-messages="stateError" required></v-select>
                <v-text-field class="courier-zip-field" label="Zip" v-model="courierModel.Address.Zip" :counter=5 :rules="[rulesZip, rulesRequired]" required></v-text-field>
              </v-layout>
              <v-checkbox class="enabled-btn" label="Enabled?" v-model="courierModel.IsEnabled"></v-checkbox>





              <h2>Integration</h2>
              <v-select class="integration-select" :items="apiTypes" v-model="courierModel.ApiType" label="Select Api Type" single-line item-text="name" item-value="id" bottom required></v-select>
              <div class="api-option-fields" v-if="courierModel.ApiType == 1 || courierModel.ApiType == 2">
                <div>
                  <v-text-field class="api-url-field" label="Api Url" v-model="courierModel.ApiEndpoint"></v-text-field>
                  <v-text-field class="api-username-field" label="Api UserName" v-model="courierModel.ApiUserName"></v-text-field>
                  <v-text-field class="api-password-field" label="Api Password" type="password" v-model="courierModel.ApiPassword"></v-text-field>






                  <div v-if="courierModel.ApiType == 1">
                    <v-text-field class="api-website-field" label="eCourier Website" v-model="courierModel.ApiWebsite"></v-text-field>
                    <v-text-field class="api-customer-key-field" label="eCourier Customer Key" v-model="courierModel.ApiCustomerKey"></v-text-field>
                  </div>

                  
                  <div v-if="courierModel.ApiType == 2">
                    <v-layout row wrap>
                      <v-select class="msas-select" :items="msas" v-model="courierModel.MSAAssignment" label="Default MSA" single-line bottom></v-select>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="remove-default-msas-btn" text icon @click="removeDefaultMsa(courierModel)">
                            <v-icon>remove_circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove MSA</span>
                      </v-tooltip>
                    </v-layout>
                    <v-layout row wrap>
                      <v-text-field class="api-default-service-input" v-model="courierModel.ApiDefaultService" label="Default Service"></v-text-field>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="service-modal-btn" icon v-on:click="serviceModal()">
                            <v-icon>power</v-icon>
                          </v-btn>
                        </template>
                        <span>Check Api Connection</span>
                      </v-tooltip>
                    </v-layout>
                  </div>
                </div>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import { EVENTS } from "./config";
import ApiService from "./ApiServiceModal";
import US_STATES from "@/assets/data/US_STATES";
import US_MSAS from "@/assets/data/US_MSAS";
import { COURIER_CONFIG_NAMESPACE } from "./store/courierConfigStore";
import RulesMixin from "@/mixins/RulesMixin.js";
export default {
  name: "AddEditCourier",
  components: { "api-service": ApiService },
  mixins: [RulesMixin],
  data() {
    return {
      loading: false,
      valid: true,
      stateError: null,
      courierDuplicate: false,
      courierModel: {
        Address: {}
      },
      states: US_STATES,
      msas: US_MSAS,
      apiTypes: [
        { id: 0, name: "No Api" },
        { id: 1, name: "eCourier" },
        { id: 2, name: "Axis" }
      ],
      addCourier: false
    };
  },
  computed: {
    ...mapGetters(COURIER_CONFIG_NAMESPACE, [])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on(EVENTS.OPEN_DETAIL_DIALOG, this.load);
    this.$on(EVENTS.SET_DEFAULT_API_SERVICE, this.setDefaultService);
  },
  methods: {
    close() {
      this.courierModel = { Address: {} };
      this.addCourier = false;
      this.courierDuplicate = false;
    },
    serviceModal() {
      this.$emit(EVENTS.OPEN_SERVICE_DIALOG, this.courierModel);
    },
    load(courier) {
      if (courier) {
        this.addCourier = true;
        this.courierModel = Object.assign({}, courier);
      }
    },
    removeDefaultMsa(item) {
      item.MSAAssignment = null;
    },
    setDefaultService(serviceName) {
      this.courierModel.ApiDefaultService = serviceName;
      this.$forceUpdate();
    },
    submit(overrideDuplicate) {
      return this.$store
        .dispatch(
          `${COURIER_CONFIG_NAMESPACE}/checkCourierDuplicate`,
          this.courierModel
        )
        .then(res => {
          this.courierDuplicate = res;
          if (
            this.$refs.form.validate() &&
            (!this.courierDuplicate || overrideDuplicate === true) &&
            this.courierModel.Address.State
          ) {
            this.$store
              .dispatch(
                `${COURIER_CONFIG_NAMESPACE}/saveCourier`,
                this.courierModel
              )
              .then(val => {
                this.courierModel = { Address: {} };
                this.addCourier = false;
                this.stateError = null;
              });
          } else if (!this.courierModel.Address.State) {
            this.stateError = "Please Enter State";
          }
        });
    }
  }
};
</script>
